
<template>
	<div class="announcements-page" v-if="shootId" :key="shootId">
		<Announcements
			ref="announcements"
			show-debug-status
			:club-id="clubId"
			:shoot-id="shootId"
			:scroll-speed="scrollSpeed"
			:enable-keyboard-shortcuts="false"
            :toggle-show-hide-interval="toggleShowHideInterval || -1"
		/>
	</div>
    <span v-else>
        <span> No active shoot</span>
    </span>
</template>

<script>
import Announcements from '@/components/Announcements.vue';
import dayjs from 'dayjs';

export default {
	name: 'AnnouncementsPage',
	components: {
		Announcements,
	},
	data() {
		return {
            clubId: null,
			shootId: null,
			scrollSpeed: 1, // default
            toggleShowHideInterval: null,
		};
	},
	async mounted() {
        console.warn('⚙️ Available Query Params: ?club=123 (required), ?scrollSpeed=2 (1-5, higher is slower), ?toggleShowHideInterval=5000 (interval in ms, -1 for default behavior)');
		this.clubId = this.$route.query.club;
		// Allow scroll speed to be set via ?scrollSpeed=2 (1-5, higher is slower)
		if (this.$route.query.scrollSpeed) {
			const val = parseInt(this.$route.query.scrollSpeed, 10);
			if (!isNaN(val) && val > 0 && val <= 5) {
				this.scrollSpeed = val;
				// Document this in the console
				console.info('✨[AnnouncementsPage] Scroll speed set via URL parameter:', val, '\nUsage: /announcements?club=123&scrollSpeed=2 (1=slowest, 5=fastest)');
			} else {
				console.warn('✨[AnnouncementsPage] Invalid scrollSpeed parameter, using default. Must be 1-5.');
			}
		}
		if (!this.clubId) {
			console.error('Club ID not provided in query params');
			return;
		}

        if(this.$route.query.toggleShowHideInterval) {
            const val = parseInt(this.$route.query.toggleShowHideInterval, 10);
            if (!isNaN(val) && (val > 0 || val === -1)) {
                this.toggleShowHideInterval = val;
                console.info('✨[AnnouncementsPage] toggleShowHideInterval set via URL parameter:', val, '\nUsage: /announcements?club=123&toggleShowHideInterval=5000 (interval in ms)');
            } else {
                this.toggleShowHideInterval = -1; // Use default behavior
                console.warn('✨[AnnouncementsPage] Invalid toggleShowHideInterval parameter, using default. Must be a positive integer or -1.');
            }
        }

		this.start();

		//At 1 am reset the announcements so that they will be re-fetched on next load
		const now = dayjs();
		const nextReset = now.add(1, 'day').startOf('day');
		const msUntilReset = nextReset.diff(now);
		setTimeout(() => {
			this.start();
		}, msUntilReset);
	},
	methods: {
		async start() {
			await this.getLatestShoot();
			// The Announcements component will handle fetching when shootId is set
		},
		async getLatestShoot() {
			try {
				const response = await this.$api.get('/public/shoot?filter=current');
				const shoots = response.data;
				const clubShoots = shoots.filter(
					(shoot) => shoot.ClubId == this.clubId
				);
				if (clubShoots.length > 0) {
					// Sort by start date descending to get the latest
					const latestShoot = clubShoots.sort((a, b) =>
						dayjs(b.StartDate).diff(dayjs(a.StartDate))
					)[0];
					this.shootId = latestShoot.ShootId;
					window.setupConnection(this.shootId, this.clubId);
				} else {
					console.error('No current shoots found for this club');
				}
			} catch (error) {
				console.error('Error fetching shoots:', error);
			}
		},
	},
};
</script>

<style scoped>
.announcements-page {
	background: rgba(0,255,128,1);
	height: 100vh;
	width: 100vw;
	position: fixed;
	top: 0;
	left: 0;
}
</style>
